import { WorkflowItem } from '@cibo/core'
import { ListCard } from '@cibo/ui'
import { Stack } from '@mui/material'
import { GridRowParams } from '@mui/x-data-grid-pro'
import { EnrollmentList } from 'components'
import { EnrollmentListLegend } from 'components/EnrollmentList/EnrollmentListLegend'
import { PROGRAM_ROUTES } from 'navigation/types/routes'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'
import { ENGAGEMENT_PATHS } from '../../navigation/types/engagementRoutes'
import { useEnrollments } from './useEnrollments'

export const EnrollmentsTable = () => {
  const { t } = useTranslation('impact/pages/Enrollments')
  const navigate = useNavigate()
  const { sortedEnrollmentsWithContent: items, isLoading } = useEnrollments()
  return (
    <Stack spacing={2}>
      <ListCard title={t('programs')} subTitle={t('openEnrollments')}>
        <EnrollmentList
          loading={isLoading}
          onRowClick={({ id, row }: GridRowParams<WorkflowItem>) => {
            if (row.wfType === 'programEngagement') {
              navigate(
                generatePath(`${PROGRAM_ROUTES.ENGAGEMENTS}/${ENGAGEMENT_PATHS.ENGAGEMENT}`, {
                  engagementId: id as string,
                  programId: row.programId,
                })
              )
            } else {
              navigate(
                generatePath(PROGRAM_ROUTES.ENROLL_DETAIL, {
                  workflowId: id as string,
                  programId: row.programId,
                })
              )
            }
          }}
          rows={items}
          pagination
          hideFooter={false}
        />
      </ListCard>
      <EnrollmentListLegend />
    </Stack>
  )
}
